import { render } from "./ObjectViewerComponent.vue?vue&type=template&id=9b19032e"
import script from "./ObjectViewerComponent.vue?vue&type=script&lang=js"
export * from "./ObjectViewerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__